<template>
  <section class="hero is-fullheight cart-page">
    <PmNavbar />

      <asModalDialog
        heading-text="3d esikatselu"
        :show-ok="false"
        :show-cancel="false"
        width="80%"
        min-width="500px"
        ref="previewModal"
        class="is-marginless"
      >
        <preview3d :textureWidth=1000 :textureHeight=400 :gblVariable="'Exterior'" :texture="texture" :uri="currentTextureUri"/>
      </asModalDialog>

    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-9 has-text-centered-mobile">
            <div class="columns white-bg">
              <div class="column is-12">
                <h1 class="is-ubuntu font-secondary has-text-centered-mobile">Oma Tilisi</h1>
              </div>
            </div>

            <div class="columns white-bg" v-if="account!=null && account.contact!=undefined">
              <div class="column is-12">
                <h3 class="is-ubuntu font-secondary has-text-centered-mobile">Hei {{account.contact.recv_name}}</h3>
              </div>
            </div>

            <div class="columns white-bg" v-if="get_orders.length > 0">
              <div class="column is-12">
                <h3 class="is-ubuntu font-secondary">Tilaukset</h3>
              </div>
            </div>

            <div class="columns is-multiline white-bg">
              <!-- Start Cart Line -->
              <div v-for="(order, index) in get_orders" :key="index" class="column is-12 border-bottom">
                <div class="columns">
                  <div class="column is-3">
                    <p style="font-weight: bold;">Tilaus #{{order.order_number}}</p>
                    <div v-for="(item, indexx) in order.items" >
                      <span v-if="$store.getters.getProductById(item.product) != undefined" style="font-size: 12px;">
                        {{$store.getters.getProductById(item.product).name}} x {{item.amount}}
                      </span>


                      <div v-if="$store.getters.getProductById(item.product) != undefined" class="product-row">
                        <figure class="image" v-if="$store.getters.getProductById(item.product).resource_type === 'Cup'">
                          <img :src="item.thumbnail_url" />
                        </figure>

                        <span class="is-clickable icon-right" @click="openPreview(item)" v-if="$store.getters.getProductById(item.product).resource_type === 'Cup'">
                          <i class="fas fa-eye"></i>
                        </span>

                        <template v-if="$store.getters.getProductById(item.product).resource_type === 'CandyBox'">
                          <a v-if="item.pdf_url" :href="item.pdf_url" target="_blank" class="is-clickable icon-right" title="Lataa PDF">
                            <i class="fas fa-file-pdf"></i>
                          </a>
                          <a v-if="getProofToken(item)" :href="getProofUrl(getProofToken(item))" target="_blank" class="is-clickable icon-right" title="Avaa painovedos">
                            <i class="fas fa-eye"></i>
                          </a>
                          <span v-if="getProofToken(item)" class="is-clickable icon-right" @click="copyProofLink(getProofToken(item))" title="Kopioi painovedoslinkki">
                            <i class="fas fa-link"></i>
                          </span>
                        </template>
                      </div>
                    </div>

                    <p style="font-size: 12px;">{{getOrderDate(order.created)}}</p>
                    <p style="font-size: 12px;">{{getOrderStatus(order.status)}}</p>

                  </div>

                  <div class="column is-3 has-text-centered">

                  </div>

                  <div class="column is-3 has-text-centered">

                  </div>

                  <div class="column is-3 has-text-centered">
                    <button class="pyroll-button dark-blue-bg font-white" @click="repeatOrder(order)">Uusintatilaus</button>
                  </div>

                </div>
              </div>

            </div>
            <button class="pyroll-button purple-bg font-white mt-5" @click="this.$router.push({ name: 'Landing' })">
              Jatka kauppaan
            </button>
          </div>
          <div class="column is-3 side-menu has-text-centered-mobile">
            <ul class="gray-bottom-border pb-5">
              <li>
                <a @click="$router.push({name: 'Profile'})">
                  Omat tiedot
                </a>
              </li>
              <li>
                <a @click="$router.push({name: 'ChangePassword'})">
                  Vaihda salasanaa
                </a>
              </li>
              <li>
                <a @click="logout()">
                  Kirjaudu ulos
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import { ref } from 'vue'
import asModalDialog from "@/helpers/asModalDialog"
import {mapActions, mapGetters, mapMutations} from "vuex"
import preview3d from "@/3d/preview3d"

export default {
  components: {
    PmNavbar,
    PmFooter,
    asModalDialog,
    preview3d
  },
  setup: () => {
    const dataUrl = ref(null)
    const currentTextureUri = ref(null)

    return {
      dataUrl,
      currentTextureUri
    }
  },
  mounted() {
    this.setSpinnerState(false)
    this.getOrders().then(() => {
      this.getDesigns().then(() => {
        this.getAccount().then(() => {
        })
      })
    })
  },
  methods: {
    ...mapActions({
      getDesigns: 'getDesigns',
      getOrders: 'getOrders',
      getAccount: 'getAccount',
      cloneOrder: 'cloneOrder'
    }),
    ...mapMutations({
      setSpinnerState: 'setSpinnerState',
      resetStore: 'resetStore'
    }),
    ...mapGetters({
      getDesignedItems: 'getDesignedItems',
      getAccountInfo: 'getAccountInfo',
      getOrdersItems: 'getOrdersItems'
    }),
    getTextureUri(currentProduct) {
      let path = ''
      if(currentProduct.name.includes('(6 oz)')){
        path = `${process.env.BASE_URL}3d/paper-cup-6oz-v5.glb`
      }
      if(currentProduct.name.includes('(8 oz)')){
        path = `${process.env.BASE_URL}3d/paper-cup-8oz-v5.glb`
      }
      if(currentProduct.name.includes('(12 oz)')){
        path = `${process.env.BASE_URL}3d/paper-cup-12oz-v4.glb`
      }
      if(currentProduct.name.includes('(16 oz)')){
        path = `${process.env.BASE_URL}3d/paper-cups-16oz-v1.glb`
      }
      if(currentProduct.name.includes('(20 oz)')){
        path = `${process.env.BASE_URL}3d/paper-cup-20oz-v5.glb`
      }
      return path;
    },    
    openPreview(product) {
      this.currentTextureUri = this.getTextureUri(this.$store.getters.getProductById(product.product))
      this.dataUrl = product.texture_url
      this.$refs.previewModal.showModal()
    },
    getItemThumbnail(item) {
      if (item.color_image) {
        return item.color_image
      }
      if (item.thumbnail_url) {
        return item.thumbnail_url
      }
      const product = this.$store.getters.getProductById(item.product?.id || item.product)
      return product?.thumbnail || ''
    },
    getProductName(product_id) {
      if( this.$store.getters.getProductById(product_id) != undefined) {
        return this.$store.getters.getProductById(product_id).name
      } else {
        return ''
      }
    },
    getProductMaterialName(material) {
      const materials = {
        "OPT_1": "Valkoinen taivekartonki",
        "OPT_2": "Keltainen kartonki",
        "OPT_3": "Valkoinen barrier kartonki",
      }
      return materials[material]
    },
    logout() {
      this.resetStore()
      this.$router.push({ name: 'Landing' })
    },
    getOrderDate(dateStr) {
      const date = new Date(dateStr)
      const day = String(date.getDate()).padStart(2, "0")
      const month = String(date.getMonth() + 1).padStart(2, "0")
      const year = date.getFullYear()
      const formatted = `${day}.${month}.${year}`
      return formatted
    },
    getOrderStatus(status) {
      if (status == 'ORDERED') {
        return 'Laskutettu'
      }
      else if (status == 'PAID') {
        return 'Maksettu'
      }
      else if (status == 'PAYTRAIL_START') {
        return 'Paytrail maksu aloitettu'
      }
      else if (status == 'PAYTRAIL_CANCEL') {
        return 'Paytrail maksu peruttu'
      }
      else if (status == 'REJECTED') {
        return 'Hylätty'
      }
      else if (status == 'SHIPPED') {
        return 'Lähetetty'
      }
      else if (status == 'MODERATE') {
        return 'Hyväksytty'
      }
      else if (status == 'ANONYMIZED') {
        return 'Anonymisoitu'
      }
      else if (status == 'PRODUCT') {
        return 'Tuotannossa'
      }
      else {
        return status
      }
    },
    getProofToken(item) {
      const design = this.get_designed_products.find(d => d.item && d.item.id === item.id)
      return design ? design.proof_token : null
    },
    getProofUrl(token) {
      return `${window.location.origin}/print-proof/${token}`
    },
    copyProofLink(token) {
      navigator.clipboard.writeText(this.getProofUrl(token)).then(() => {
        alert('Painovedoslinkki kopioitu leikepöydälle!')
      })
    },
    repeatOrder(order) {
      this.cloneOrder(order.order_number).then((data) => {
        this.$router.push({
          name: 'Cart',
          params: {
              uuid: this.$store.getters.getOrderData.id
          }
        })
      })
    }
  },
  computed: {
    texture() {
      return [{
        dataUrl: this.dataUrl,
        posx: 0,
        posy: 0,
        width: 1000,
        height: 400,
        rotate: 0
      }]
    },
    getRecvNamePlaceholderTranslation() {
      return this.$t("message.pages.cartPage.recvNamePlaceholder")
    },
    get_designed_products() {
      return this.getDesignedItems()
    },
    get_orders() {
      return this.getOrdersItems()
    },
    account() {
      return this.$store.getters.getAccountInfo
    }
  },
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.cart-page {
  .container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .custom-black {
    color: $font-color-primary;
  }

  .white-bg {
    background-color: #ffffff;
  }

  .amount-input {
    width: 66px;
    height: 31px;
    background-color: #DEDBD9;
  }
  .border-bottom {
    border-bottom: 1px solid #707070;
  }
  .visibility-hidden {
    visibility: hidden;
  }

  // Remove arrows in number input type
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .svg-inline--fa {
    cursor: pointer;
  }

  .mandatory-fields-text {
    color: #DEDBD9;
  }
}

span.is-clickable {
  color: $pyroll-violet;
  svg {
    width: 20px;
    height: 20px;
  }
}

.text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
}

.side-menu {
  a {
    text-decoration: underline;
  }
  a:hover {
    font-weight: bold;
  }
}

.gray-bottom-border {
  border-bottom: 2px solid #D0D3D4;
}

.product-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-right {
  margin-left: 10px;
}

</style>
